export class GoogleAuthUtils {
    public static getAuthorizationFromToken = (token: string) => `GoogleSignInJwt ${token}`;
}
